class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.overlay = this.querySelector('.details-modal-overlay');
    this.searchModal = this.classList.contains('header__search') ? this.querySelector('.search-modal') : null;
    this.headerSearchPositionFrame = null;
    this.isTrackingHeaderSearch = false;
    this.onHeaderSearchViewportChange = this.onHeaderSearchViewportChange.bind(this);

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => (event.code) ? event.code.toUpperCase() === 'ESCAPE' && this.close() : ''
    );
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );
    this.querySelector('.modal__close-button').addEventListener(
      'click',
      this.close.bind(this)
    );
    if(this.overlay) {
      this.overlay.addEventListener(
        'click',
        this.close.bind(this)
      );
    }
    this.summaryToggle.setAttribute('role', 'button');
  }

  disconnectedCallback() {
    this.stopHeaderSearchPositionTracking();
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  open(event) {
    if(event) {
      event.target.closest('details').setAttribute('open', true);
    }
    
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    this.startHeaderSearchPositionTracking();

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    this.stopHeaderSearchPositionTracking();
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  startHeaderSearchPositionTracking() {
    if (!this.searchModal || this.isTrackingHeaderSearch) return;

    this.isTrackingHeaderSearch = true;
    this.updateHeaderSearchPosition();
    window.addEventListener('scroll', this.onHeaderSearchViewportChange, { passive: true });
    window.addEventListener('resize', this.onHeaderSearchViewportChange);
  }

  onHeaderSearchViewportChange() {
    if (!this.searchModal || this.headerSearchPositionFrame !== null) return;

    this.headerSearchPositionFrame = window.requestAnimationFrame(() => {
      this.headerSearchPositionFrame = null;
      this.updateHeaderSearchPosition();
    });
  }

  updateHeaderSearchPosition() {
    if (!this.searchModal) return;

    if (!this.isOpen()) {
      this.style.removeProperty('--search-modal-top');
      return;
    }

    if (window.innerWidth < 990) {
      this.style.removeProperty('--search-modal-top');
      return;
    }

    const announcementBar = document.querySelector('.new-shop-bulletin-board');
    const announcementBottom = announcementBar ? announcementBar.getBoundingClientRect().bottom : 0;
    this.style.setProperty('--search-modal-top', `${Math.max(0, announcementBottom)}px`);
  }

  stopHeaderSearchPositionTracking() {
    if (!this.isTrackingHeaderSearch) return;

    this.isTrackingHeaderSearch = false;
    window.removeEventListener('scroll', this.onHeaderSearchViewportChange);
    window.removeEventListener('resize', this.onHeaderSearchViewportChange);

    if (this.headerSearchPositionFrame !== null) {
      window.cancelAnimationFrame(this.headerSearchPositionFrame);
      this.headerSearchPositionFrame = null;
    }

    this.style.removeProperty('--search-modal-top');
  }
}

customElements.define('details-modal', DetailsModal);